import type React from 'react';
import {Box, Checkbox, FormControlLabel, Typography} from '@mui/material';
import type {PlanProps} from '../strategyProps';

const MODES = ['Disruptive', 'Adaptive'] as const;
const VALUES = ['Create', 'Deliver', 'Improve'] as const;

/** Strategy cube: Disruptive / Adaptive × Create / Deliver / Improve, two levers per cell. Feeds the key levers. */
export const StrategyCubeTool: React.FC<PlanProps> = ({plan, actions}) => {
    const {content, derived, reference, canEdit} = plan;
    const suggested = new Set(derived.cubeSuggested);
    const toggle = (key: string) => void actions.save('cube',
        content.cube.includes(key) ? content.cube.filter(k => k !== key) : [...content.cube, key], 'Levers updated.');

    return (
        <Box sx={{display: 'grid', gridTemplateColumns: '110px repeat(3, 1fr)', gap: 1, alignItems: 'start'}}>
            <span/>
            {VALUES.map(v => <Typography key={v} variant="subtitle2">{v}</Typography>)}
            {MODES.map(mode => (
                <Box key={mode} sx={{display: 'contents'}}>
                    <Typography variant="subtitle2" sx={{pt: 1}}>{mode}</Typography>
                    {VALUES.map(value => (
                        <Box key={value} sx={{border: '1px solid', borderColor: 'divider', borderRadius: 1, p: 1}}>
                            {reference.cube.filter(c => c.mode === mode && c.value === value).map(c => (
                                <FormControlLabel key={c.key} disabled={!canEdit} sx={{display: 'flex', mr: 0}}
                                                  control={<Checkbox size="small" checked={content.cube.includes(c.key)} onChange={() => toggle(c.key)}/>}
                                                  label={<Typography variant="body2">
                                                      {c.label}
                                                      {suggested.has(c.key) && <Typography component="span" variant="caption" color="primary.main"> · suggested</Typography>}
                                                  </Typography>}/>
                            ))}
                        </Box>
                    ))}
                </Box>
            ))}
        </Box>
    );
};
